export const PAGE_LABELS = {
  dashboard: 'แดชบอร์ด',
  registry: 'ทะเบียนระบบทั้งหมด',
  'register-form': 'ขึ้นทะเบียนระบบใหม่',
  'import-systems': 'นำเข้าระบบจาก Excel',
  onboard: 'Onboarding',
  offboard: 'Offboarding',
  'access-request': 'ขอสิทธิ์ระบบที่มีอยู่แล้ว',
  permissions: 'จัดการสิทธิ์ / Role',
  'smtp-settings': 'ตั้งค่า SMTP',
  'privacy-settings': 'นโยบายส่วนตัวและคุกกี้',
};

export const ROLE_LABELS = {
  IT_ADMIN: 'IT Admin (ฝ่าย IT / ทะเบียน)',
  MANAGER: 'ผู้จัดการ',
  HR: 'ฝ่ายทรัพยากรบุคคล',
  IA: 'ตรวจสอบภายใน',
  ACC: 'ฝ่ายบัญชี',
  EMPLOYEE: 'พนักงาน',
};

export const ROLE_DESCRIPTIONS = {
  IT_ADMIN: 'บทบาทองค์กรฝ่าย IT — ดูแลทะเบียนระบบและอนุมัติในฐานะ IT ไม่ใช่ผู้ดูแลสิทธิ์ของแต่ละระบบ',
  MANAGER: 'อนุมัติคำขอและดูภาพรวมของทีม',
  HR: 'ดูแล Onboard / Offboard และข้อมูลพนักงาน',
  IA: 'ติดตามความเสี่ยง การอนุมัติ และรายงานตรวจสอบ',
  ACC: 'ยืนยันยอดค่าเสียหายและงานการเงินใน Offboard',
  EMPLOYEE: 'ยื่นคำขอสิทธิ์และติดตามสถานะของตนเอง',
};

export const UI_ROLE_BY_API_ROLE = {
  IT_ADMIN: 'it',
  MANAGER: 'manager',
  HR: 'hr',
  IA: 'ia',
  ACC: 'employee',
  EMPLOYEE: 'employee',
};

export const DASHBOARD_PATH_BY_ROLE = {
  IT_ADMIN: '/dashboard/it',
  MANAGER: '/dashboard/manager',
  HR: '/dashboard/hr',
  IA: '/dashboard/ia',
  ACC: '/dashboard/employee',
  EMPLOYEE: '/dashboard/employee',
};

export const SYSTEM_TYPE_LABELS = {
  IN_HOUSE: 'บริษัทพัฒนา',
  SAAS: 'SaaS',
  LINE_GROUP: 'Line Group',
  SOCIAL_MEDIA: 'Social Media',
  FINANCIAL: 'Financial',
  DEV_TOOL: 'Dev Tool',
  AI_TOOL: 'AI Tool',
  GOVERNMENT: 'Government',
  OTHER: 'Other',
};

export const SYSTEM_TYPE_OPTIONS = [
  { value: 'IN_HOUSE', label: 'ระบบบริษัทพัฒนาเอง (In-house)', icon: '🏢' },
  { value: 'SAAS', label: 'SaaS / Outsource', icon: '☁️' },
  { value: 'LINE_GROUP', label: 'Line / WhatsApp Group', icon: '💬' },
  { value: 'SOCIAL_MEDIA', label: 'Social Media', icon: '📱' },
  { value: 'FINANCIAL', label: 'Financial System', icon: '💰' },
  { value: 'DEV_TOOL', label: 'Dev Tool (GitHub / Figma / etc.)', icon: '🛠' },
  { value: 'AI_TOOL', label: 'AI Tool', icon: '🤖' },
  { value: 'GOVERNMENT', label: 'ระบบราชการ', icon: '🏛' },
  { value: 'OTHER', label: 'อื่นๆ', icon: '' },
];

export const VENDOR_OPTIONS = [
  { group: 'บริษัทพัฒนา In-house', systemTypes: ['IN_HOUSE'], items: ['BSR IT Team (พัฒนาเอง)', 'Dev ภายนอก (จ้าง)'] },
  { group: 'Software / SaaS', systemTypes: ['SAAS', 'LINE_GROUP', 'SOCIAL_MEDIA', 'DEV_TOOL', 'AI_TOOL'], items: ['Meta (Facebook / Instagram)', 'Google LLC', 'Microsoft Corporation', 'Anthropic (Claude AI)', 'OpenAI (ChatGPT)', 'Canva Pty Ltd', 'GitHub Inc.', 'Supabase Inc.', 'Figma Inc.', 'Line Corporation', 'ByteDance (TikTok)', 'Shopee (Sea Group)', 'Peak Account', 'n8n GmbH', 'CredenData'] },
  { group: 'ราชการ / หน่วยงานรัฐ', systemTypes: ['GOVERNMENT'], items: ['กรมการค้าต่างประเทศ', 'กรมพัฒนาธุรกิจการค้า', 'กรมสรรพากร', 'กรมศุลกากร', 'สำนักงานประกันสังคม', 'กรมพัฒนาฝีมือแรงงาน'] },
  { group: 'ธนาคาร / สถาบันการเงิน', systemTypes: ['FINANCIAL'], items: ['ธนาคารไทยพาณิชย์ (SCB)', 'ธนาคารกสิกรไทย (KBank)', 'ธนาคารกรุงเทพ (BBL)', 'ธนาคารกรุงไทย (KTB)', 'ธนาคารกรุงศรีอยุธยา (BAY)', 'ธนาคารทหารไทยธนชาต (TTB)', 'ธนาคารออมสิน (GSB)', 'ธนาคาร ธ.ก.ส. (BAAC)'] },
  { group: 'ระบบการเงิน / Finance', systemTypes: ['FINANCIAL'], items: ['Internet / Corporate Banking', 'PromptPay / QR Payment', 'BillPayment Gateway', 'Payroll System (จ่ายเงินเดือน)', 'E-Tax Invoice / ใบกำกับภาษี'] },
];

/** Vendor groups filtered by system type; OTHER shows all groups */
export function getVendorOptionsForSystemType(systemType) {
  if (!systemType || systemType === 'OTHER') return VENDOR_OPTIONS;
  return VENDOR_OPTIONS.filter((group) => group.systemTypes.includes(systemType));
}

export function isVendorAllowedForSystemType(vendor, systemType) {
  if (!vendor || vendor === '__CUSTOM__') return true;
  return getVendorOptionsForSystemType(systemType).some((group) => group.items.includes(vendor));
}

export const ACCOUNT_TYPE_LABELS = {
  AD_SSO: 'AD / SSO',
  EMAIL_DEPT: 'Email แผนก',
  EMAIL_BSR: '@boonsiri.co',
  EMAIL_BF: '@boonsirifishery.com',
  // เลิกใช้แล้ว — คง label ไว้เพื่อแสดงผลระบบเก่าที่ยังมีค่านี้ค้างใน account_types
  EMAIL_BM: '@boonsirimail.co.th',
  PERSONAL: 'Account ส่วนตัว',
  SHARED: 'Shared Account',
  SHARED_GMAIL: 'Shared Account @gmail.com',
  OTHER: 'อื่น ๆ',
};

export const ACCOUNT_TYPE_OPTIONS = [
  { value: 'AD_SSO', label: 'เชื่อมกับ AD บริษัท (SSO)', desc: 'สิทธิ์ผูกกับ Windows AD — เพิ่ม/ลบ User อัตโนมัติ · disable ได้ทันทีจากส่วนกลาง', risk: 'ต่ำ', color: '#198038' },
  { value: 'EMAIL_DEPT', label: 'Email แผนก (กลาง)', desc: 'ใช้ Email กลางของแผนก — ต้อง Reset Password ทุกครั้งที่มีคนลาออก', risk: 'กลาง', color: '#b28600' },
  { value: 'EMAIL_BSR', label: 'Email พนักงาน @boonsiri.co', desc: 'ใช้ Email บริษัท Boonsiri — ต้องถอนสิทธิ์เมื่อพ้นสภาพ', risk: 'กลาง', color: '#0043ce' },
  { value: 'EMAIL_BF', label: 'Email พนักงาน @boonsirifishery.com', desc: 'ใช้ Email บริษัท Boonsiri Fishery — ต้องถอนสิทธิ์เมื่อพ้นสภาพ', risk: 'กลาง', color: '#0043ce' },
  { value: 'PERSONAL', label: 'Account ส่วนตัวของพนักงาน', desc: 'Facebook / Line / อื่นๆ ที่ผูกกับบัญชีส่วนตัว — ไม่สามารถ revoke จากส่วนกลาง · ต้องมี Backup Admin', risk: 'สูง', color: '#da1e28' },
  { value: 'SHARED', label: 'Shared Account', desc: 'หลายคนใช้ Username/Password ร่วมกัน — ต้องกำหนดผู้รับผิดชอบหลัก', risk: 'กลาง', color: '#b28600' },
  { value: 'SHARED_GMAIL', label: 'Shared Account Email @gmail.com', desc: 'Email Gmail กลางที่หลายคนใช้ร่วมกัน — อยู่นอก Workspace บริษัท จึง revoke จากส่วนกลางไม่ได้ · ต้องมี Backup Admin และเปลี่ยนรหัสทุกครั้งที่มีคนลาออก', risk: 'สูง', color: '#da1e28' },
  { value: 'OTHER', label: 'อื่นๆ', desc: 'ระบุเพิ่มเติม', risk: 'ต่ำ', color: '#6f6f6f' },
];

export const DEPT_EMAIL_DOMAIN_OPTIONS = [
  '@boonsirifishery.com',
  '@boonsiri.co',
  '@boonsirigroup',
  '@gmail.com',
];

export const REVIEW_CYCLE_LABELS = {
  '3_MONTHS': '3 เดือน',
  '6_MONTHS': '6 เดือน',
  '12_MONTHS': '12 เดือน',
  AD_HOC: 'ตามเหตุการณ์',
};

export const RISK_LEVEL_LABELS = {
  LOW: 'ต่ำ',
  MEDIUM: 'กลาง',
  HIGH: 'สูง',
  CRITICAL: 'สูงมาก',
};

export const SYSTEM_STATUS_LABELS = {
  DRAFT: 'ร่าง',
  PENDING: 'รออนุมัติ',
  ACTIVE: 'ใช้งาน',
  INACTIVE: 'ปิดใช้งาน',
  ARCHIVED: 'เก็บถาวร',
};

export const ACCESS_ROLE_LABELS = {
  ADMIN: 'Admin',
  EDITOR: 'Editor',
  APPROVER: 'Approver',
  EXPORTER: 'Exporter',
  VIEWER: 'Viewer',
  MEMBER: 'Member',
  REPORT_ONLY: 'Report Only',
};

export const DURATION_TYPE_LABELS = {
  PERMANENT: 'ถาวร',
  TEMPORARY: 'ชั่วคราว',
};

export const REQUEST_TYPE_LABELS = {
  NEW: 'ขอสิทธิ์ใหม่',
  BULK_ACCESS: 'ขอเข้าใช้งานระบบ (แบบตาราง)',
  MODIFY: 'ปรับสิทธิ์',
  RESET: 'Reset Password',
  DECOMMISSION: 'ขอปิดระบบ',
  SOFTWARE_INSTALL: 'ขออนุมัติติดตั้งโปรแกรม',
  VPN_ACCESS: 'ขอเข้าใช้งานระบบ (รายบุคคล)',
};

export const REQUEST_STATUS_LABELS = {
  DRAFT: 'ร่าง',
  PENDING: 'รออนุมัติ',
  APPROVED: 'อนุมัติแล้ว',
  REJECTED: 'ปฏิเสธ',
  CANCELLED: 'ยกเลิก',
  COMPLETED: 'เสร็จสิ้น',
};

export const APPROVER_ROLE_LABELS = {
  LINE_MANAGER: 'Line Manager',
  IT_ADMIN: 'IT Admin (ฝ่าย IT / ทะเบียน)',
  SYSTEM_ADMIN: 'ผู้ดูแลสิทธิ์ของระบบ',
  SYSTEM_OWNER: 'System Owner (เจ้าของระบบ)',
  HR: 'HR',
  INTERNAL_AUDIT: 'Internal Audit',
  C_LEVEL: 'C-Level',
};

export const TASK_PRIORITY_LABELS = {
  LOW: 'ต่ำ',
  MEDIUM: 'กลาง',
  HIGH: 'สูง',
  CRITICAL: 'สูงมาก',
};

export const TASK_STATUS_LABELS = {
  PENDING: 'รอดำเนินการ',
  IN_PROGRESS: 'กำลังทำ',
  DONE: 'เสร็จแล้ว',
  OVERDUE: 'เกินกำหนด',
  SKIPPED: 'ข้าม',
};

export const POSITION_LEVEL_LABELS = {
  C_LEVEL: 'C-Level',
  MANAGER: 'Manager',
  SUPERVISOR: 'Supervisor',
  OPERATIONAL: 'Operational',
  PART_TIME: 'Part-time',
  IT_DEV: 'IT / Dev',
};

export const POSITION_LEVEL_OPTIONS = Object.entries(POSITION_LEVEL_LABELS).map(([value, label]) => ({
  value,
  label,
}));

export const POSITION_LEVEL_ORDER = ['C_LEVEL', 'MANAGER', 'SUPERVISOR', 'IT_DEV', 'OPERATIONAL', 'PART_TIME'];

const ON_BEHALF_POSITION_LEVELS = new Set(['C_LEVEL', 'MANAGER', 'SUPERVISOR']);

export function classifyPositionLevel(name) {
  if (!name) return 'OPERATIONAL';
  const n = name.trim();
  if (/^ประธาน|Chief|\bCEO\b|\bCFO\b|\bCOO\b|\bCTO\b|\bCSO\b|\bCMO\b|\bCIO\b/i.test(n)) return 'C_LEVEL';
  if (/^ผู้ช่วยผู้จัดการ|^ผู้จัดการ|\bManager\b/i.test(n)) return 'MANAGER';
  if (/^หัวหน้า|\bSupervisor\b|\bLead\b/i.test(n)) return 'SUPERVISOR';
  if (/Part[- ]?time|ลูกจ้างชั่วคราว|\bรายวัน\b/i.test(n)) return 'PART_TIME';
  if (/^IT\b|Developer|\bDev\b/i.test(n)) return 'IT_DEV';
  return 'OPERATIONAL';
}

export function resolvePositionLevel(userOrPosition) {
  if (!userOrPosition) return 'OPERATIONAL';
  if (typeof userOrPosition === 'string') return classifyPositionLevel(userOrPosition);
  if (userOrPosition.positionLevel && POSITION_LEVEL_ORDER.includes(userOrPosition.positionLevel)) {
    return userOrPosition.positionLevel;
  }
  return classifyPositionLevel(userOrPosition.position);
}

/** Supervisor+ only — IT Admin / HR do not bypass position level. */
export function canRequestAccessOnBehalf(user) {
  return ON_BEHALF_POSITION_LEVELS.has(resolvePositionLevel(user));
}

export const ADMIN_MODE_OPTIONS = [
  { value: 'IT', label: 'IT ดูแลหลัก' },
  { value: 'OWNER', label: 'Owner ดูแลหลัก' },
  { value: 'BOTH', label: 'IT + Owner ร่วมกันดูแล' },
  { value: 'DEV', label: 'Dev ผู้พัฒนา' },
];

export const REVIEW_ASSIGNEE_OPTIONS = [
  { value: 'IT_ADMIN', label: 'IT Admin (ฝ่าย IT / ทะเบียน)' },
  { value: 'SYSTEM_OWNER', label: 'System Owner (เจ้าของระบบ)' },
  { value: 'HR', label: 'HR' },
  { value: 'INTERNAL_AUDIT', label: 'Internal Audit' },
  { value: 'C_LEVEL', label: 'C-Level' },
];

export const RISK_DATA_TYPE_OPTIONS = [
  { value: 'FINANCIAL', label: 'ข้อมูลการเงิน / บัญชี', desc: 'เช่น ยอดเงินในบัญชี, งบการเงิน, เงินเดือนพนักงาน, รายรับรายจ่าย', icon: '💰', score: 25 },
  { value: 'CUSTOMER', label: 'ข้อมูลลูกค้า / คู่ค้า', desc: 'เช่น ชื่อ-เบอร์ลูกค้า, วงเงินเครดิต, สัญญาซื้อขาย, ข้อมูลซัพพลายเออร์', icon: '👥', score: 22 },
  { value: 'EMPLOYEE', label: 'ข้อมูลส่วนตัวพนักงาน', desc: 'เช่น เงินเดือน, ที่อยู่, เลขบัตรประชาชน, ประวัติการทำงาน', icon: '👤', score: 20 },
  { value: 'IT_SYSTEM', label: 'ข้อมูลระบบ IT / รหัสผ่าน', desc: 'เช่น รหัสเข้าระบบ, ตั้งค่าระบบ, โค้ดโปรแกรมที่บริษัทพัฒนา', icon: '💻', score: 20 },
  { value: 'INVENTORY', label: 'ข้อมูลสินค้า / คลัง / จัดส่ง', desc: 'เช่น จำนวนสินค้าคงเหลือ, ราคาต้นทุน, คำสั่งซื้อ, ตารางรถขนส่ง', icon: '📦', score: 12 },
  { value: 'REPORTS', label: 'รายงาน / ตารางงาน ทั่วไป', desc: 'เช่น รายงานประจำวัน, ตารางนัดหมาย, KPI, สรุปยอดขาย', icon: '📋', score: 8 },
  { value: 'PUBLIC', label: 'ข้อมูลทั่วไป / ประชาสัมพันธ์', desc: 'เช่น โพสต์ Facebook, รูปภาพสินค้า, เนื้อหาโฆษณา — ไม่มีข้อมูลลับ', icon: '🌐', score: 3 },
];

export const RISK_ACCESS_OPTIONS = [
  { value: 'INTERNET', label: 'เปิดใช้ผ่านอินเทอร์เน็ตได้ทุกที่', desc: 'เช่น เปิดเว็บไซต์หรือแอปได้จากที่ไหนก็ได้ ไม่ต้องอยู่ออฟฟิศ', icon: '🌍', score: 20 },
  { value: 'OFFICE_VPN', label: 'ใช้ได้เฉพาะในออฟฟิศ / VPN', desc: 'เช่น ต้องต่อ WiFi บริษัทหรือ VPN ถึงจะเปิดได้ — เปิดจากข้างนอกไม่ได้', icon: '🔒', score: 2 },
];

export const RISK_INTEGRATION_OPTIONS = [
  { value: 'EXTERNAL_API', label: 'เชื่อมกับระบบภายนอกบริษัท', desc: 'เช่น ต่อกับ Shopee, LINE, ธนาคาร, หน่วยงานรัฐ, ซัพพลายเออร์', icon: '🔗', score: 15 },
  { value: 'INTERNAL', label: 'เชื่อมกับระบบอื่นในบริษัท', desc: 'เช่น ดึงข้อมูลจาก BI-one, ระบบบัญชี, ระบบคลังสินค้า', icon: '🏢', score: 10 },
  { value: 'MOBILE', label: 'ใช้ผ่านมือถือส่วนตัว', desc: 'เช่น ติดตั้งแอปในมือถือของพนักงาน, ใช้ Line/WhatsApp ส่วนตัว', icon: '📱', score: 5 },
];

export const RISK_USER_ROLE_OPTIONS = [
  { value: 'ADMIN', label: 'ผู้ดูแลระบบ (Admin)', desc: 'เพิ่ม/ลบคนใช้งาน, ตั้งค่าระบบ, ลบข้อมูลทุกอย่างได้', icon: '⚙️', score: 25 },
  { value: 'EDITOR', label: 'แก้ไขข้อมูลได้', desc: 'สร้าง แก้ไข ลบข้อมูลในระบบได้ แต่จัดการคนใช้งานไม่ได้', icon: '✏️', score: 18 },
  { value: 'APPROVER', label: 'ผู้อนุมัติรายการ', desc: 'ตรวจสอบแล้วกดอนุมัติ/ปฏิเสธ เช่น อนุมัติโอนเงิน, อนุมัติคำสั่งซื้อ', icon: '📊', score: 14 },
  { value: 'EXPORTER', label: 'ดูและดาวน์โหลดข้อมูล', desc: 'ดูรายงาน สั่งพิมพ์ หรือดาวน์โหลด Excel ได้ แต่แก้ไขไม่ได้', icon: '📤', score: 10 },
  { value: 'VIEWER', label: 'ดูอย่างเดียว', desc: 'ดูข้อมูลบนหน้าจอได้เท่านั้น — สั่งพิมพ์หรือดาวน์โหลดไม่ได้', icon: '👁', score: 4 },
  { value: 'MEMBER', label: 'สมาชิกกลุ่ม (แชท)', desc: 'เข้ากลุ่ม Line/WhatsApp ได้ ส่ง-อ่านข้อความ — ไม่มีสิทธิ์จัดการกลุ่ม', icon: '📱', score: 8 },
];

export const RESET_REASON_OPTIONS = [
  { value: 'FORGOT', label: 'ลืมรหัสผ่าน' },
  { value: 'LOCKED', label: 'บัญชีถูกล็อก' },
  { value: 'POLICY', label: 'เปลี่ยนตาม policy' },
  { value: 'SECURITY', label: 'เหตุผลด้านความปลอดภัย' },
  { value: 'OTHER', label: 'อื่นๆ' },
];

export const URGENCY_OPTIONS = [
  { value: 'NORMAL', label: 'ปกติ' },
  { value: 'URGENT', label: 'เร่งด่วน' },
];

export const TICKET_STATUS_LABELS = {
  OPEN: 'เปิด Ticket',
  IN_PROGRESS: 'กำลังดำเนินการ',
  PENDING: 'ติดปัญหา',
  DELAY: 'เกินกำหนด',
  COMPLETE: 'เสร็จสิ้น',
  SKIPPED: 'ข้าม',
};

export const TICKET_ASSIGNEE_LABELS = {
  IT_ADMIN: 'IT (ฝ่าย IT)',
  HR: 'HR',
  ADMIN: 'หัวหน้างาน',
  ACC: 'บัญชี',
  SYSTEM_ADMIN: 'ผู้ดูแลสิทธิ์ของระบบ',
};

export function ticketStatusBadgeClass(status) {
  if (status === 'COMPLETE') return 'badge-green';
  if (status === 'SKIPPED') return 'badge-purple';
  if (status === 'IN_PROGRESS') return 'badge-blue';
  if (status === 'PENDING') return 'badge-orange';
  if (status === 'DELAY') return 'badge-red';
  return 'badge-grey';
}

export function normalizeTicketStatus(status) {
  if (!status) return 'OPEN';
  const value = String(status).toUpperCase();
  const aliases = {
    NEW: 'OPEN',
    TODO: 'OPEN',
    DONE: 'COMPLETE',
    OVERDUE: 'DELAY',
    BLOCKED: 'PENDING',
    ISSUE: 'PENDING',
    ON_HOLD: 'PENDING',
    WAITING: 'PENDING',
  };
  return aliases[value] || value;
}

function hasStuckReason(task) {
  return Boolean(String(task?.pendingReason || '').trim());
}

export function getTicketStatus(task) {
  // Primary workflow badge — overdue is a separate overlay (isTicketOverdue)
  return getRawTicketStatus(task);
}

export function getRawTicketStatus(task) {
  if (!task) return 'OPEN';
  const source = task.rawStatus ?? task.status;
  const normalized = normalizeTicketStatus(source);
  if (normalized === 'COMPLETE' || normalized === 'SKIPPED') return normalized;
  // True "ติดปัญหา" only when a reason was recorded via pause action
  if (hasStuckReason(task)) return 'PENDING';
  // DB stores not-started as PENDING; backend may map status→OPEN/DELAY — never treat bare PENDING as stuck
  if (normalized === 'PENDING' || normalized === 'OPEN' || normalized === 'DELAY') return 'OPEN';
  // ไม่มีผู้รับ = ยังไม่มีใคร accept
  if (!task.assignedTo?.userId) return 'OPEN';
  return normalized;
}

export function isTicketOverdue(task) {
  if (!task?.dueDate) return false;
  const raw = getRawTicketStatus(task);
  if (raw === 'COMPLETE' || raw === 'SKIPPED') return false;
  return new Date(task.dueDate) < new Date();
}

export function isTicketComplete(task) {
  const raw = getRawTicketStatus(task);
  return raw === 'COMPLETE' || raw === 'SKIPPED';
}

export function isTicketStatus(task, status) {
  const expected = normalizeTicketStatus(status);
  if (expected === 'PENDING') {
    return getRawTicketStatus(task) === 'PENDING' || hasStuckReason(task);
  }
  if (expected === 'DELAY') {
    return isTicketOverdue(task);
  }
  return getRawTicketStatus(task) === expected;
}

export function formatTicketStatus(value) {
  return getLabel(TICKET_STATUS_LABELS, normalizeTicketStatus(value));
}

export function getLabel(map, value, fallback = '-') {
  if (value === undefined || value === null || value === '') {
    return fallback;
  }

  return map[value] || String(value).replaceAll('_', ' ');
}

export function getInitials(name = '') {
  const segments = String(name).trim().split(/\s+/).filter(Boolean);
  if (segments.length === 0) return 'NA';
  return segments.slice(0, 2).map((segment) => segment[0]).join('').toUpperCase();
}

export function toUiRole(role) {
  return UI_ROLE_BY_API_ROLE[role] || 'employee';
}

export function riskClass(level) {
  if (level === 'CRITICAL' || level === 'HIGH') return 'risk-high';
  if (level === 'MEDIUM') return 'risk-med';
  return 'risk-low';
}

export function riskBadgeClass(level) {
  if (level === 'CRITICAL') return 'badge-red';
  if (level === 'HIGH') return 'badge-orange';
  if (level === 'MEDIUM') return 'badge-yellow';
  return 'badge-green';
}

export function statusBadgeClass(status) {
  if (['ACTIVE', 'APPROVED', 'DONE', 'COMPLETED'].includes(status)) return 'badge-green';
  if (['PENDING', 'IN_PROGRESS', 'DRAFT'].includes(status)) return 'badge-blue';
  if (['REJECTED', 'CANCELLED', 'ARCHIVED', 'OVERDUE'].includes(status)) return 'badge-red';
  if (status === 'INACTIVE') return 'badge-grey';
  return 'badge-orange';
}

/** HR employee employment status — employeeStatus | empStatus | status */
export function empEmployeeStatus(emp) {
  if (!emp) return '';
  return emp.employeeStatus || emp.empStatus || emp.status || '';
}

export function employeeStatusBadgeClass(status) {
  if (!status) return 'badge-grey';
  const normalized = String(status).trim().toUpperCase();
  if (['พ้นสภาพ', 'ลาออก', 'INACTIVE', 'TERMINATED', 'RESIGNED'].some((t) => normalized.includes(t.toUpperCase()))) {
    return 'badge-red';
  }
  // HR values: บรรจุ (permanent) / ทดลองงาน (probation)
  if (normalized.includes('ทดลองงาน') || normalized.includes('PROBATION')) return 'badge-yellow';
  if (['บรรจุ', 'ปกติ', 'ACTIVE', 'NORMAL', 'WORKING'].some((t) => normalized.includes(t.toUpperCase()))) {
    return 'badge-green';
  }
  return 'badge-grey';
}

export function systemTypeBadgeClass(type) {
  if (['IN_HOUSE', 'DEV_TOOL'].includes(type)) return 'badge-blue';
  if (type === 'SAAS') return 'badge-orange';
  if (type === 'FINANCIAL') return 'badge-red';
  if (type === 'AI_TOOL') return 'badge-purple';
  if (['LINE_GROUP', 'SOCIAL_MEDIA'].includes(type)) return 'badge-yellow';
  return 'badge-grey';
}

export function formatDate(value, options = {}) {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  return new Intl.DateTimeFormat('th-TH', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    ...options,
  }).format(date);
}

/** YYYY-MM-DD for <input type="date"> using local calendar (avoid UTC off-by-one). */
export function toDateInputValue(value) {
  if (!value) return '';
  if (typeof value === 'string') {
    const bare = value.match(/^(\d{4}-\d{2}-\d{2})$/);
    if (bare) return bare[1];
  }
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function formatDateTime(value) {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  return new Intl.DateTimeFormat('th-TH', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}

export function formatNumber(value) {
  if (value === undefined || value === null || value === '') return '-';
  return new Intl.NumberFormat('th-TH').format(Number(value));
}

export function asArray(value) {
  if (Array.isArray(value)) return value;
  if (value === undefined || value === null) return [];
  return [value];
}

export function extractItems(data) {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.items)) return data.items;
  return [];
}

export function formatSystemType(value) {
  return getLabel(SYSTEM_TYPE_LABELS, value);
}

export function formatAccountType(value) {
  return getLabel(ACCOUNT_TYPE_LABELS, value);
}

export function formatRiskLevel(value) {
  return getLabel(RISK_LEVEL_LABELS, value);
}

export function formatSystemStatus(value) {
  return getLabel(SYSTEM_STATUS_LABELS, value);
}

export function formatRequestType(value) {
  return getLabel(REQUEST_TYPE_LABELS, value);
}

export function formatRequestStatus(value) {
  return getLabel(REQUEST_STATUS_LABELS, value, getLabel(TASK_STATUS_LABELS, value));
}

export function formatAccessRole(value) {
  return getLabel(ACCESS_ROLE_LABELS, value);
}

export function formatDurationType(value) {
  return getLabel(DURATION_TYPE_LABELS, value);
}

export function formatApproverRole(value) {
  return getLabel(APPROVER_ROLE_LABELS, value);
}

export function formatPriority(value) {
  return getLabel(TASK_PRIORITY_LABELS, value);
}

export function formatTaskStatus(value) {
  return getLabel(TASK_STATUS_LABELS, value);
}

export function formatPositionLevel(value) {
  return getLabel(POSITION_LEVEL_LABELS, value);
}
